import request from '@/utils/request';

export function adDataApi() {
    return{
        // 投放数据
        adDataList: params => {
            return request({
                url: '/admin/addata/index',
                method: 'get',
                params,
            });
        },

        //消耗-小说排行
        costMovieList: params => {
            return request({
                url: '/admin/addata/cost/movies/rank',
                method: 'get',
                params,
            });
        },

        //消耗-渠道排行
        costChannelList: params => {
            return request({
                url: '/admin/addata/cost/channels/rank',
                method: 'get',
                params,
            });
        },
        //今日新增充值金额-小说排行
        rechargeMoneyMovieList: params => {
            return request({
                url: '/admin/addata/nrm/movies/rank',
                method: 'get',
                params,
            });
        },
        //今日新增充值金额-小说排行
        rechargeMoneyChannelList: params => {
            return request({
                url: '/admin/addata/nrm/channels/rank',
                method: 'get',
                params,
            });
        },
    }
}